
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { clientFormSteps, FormStep, tabs } from "@/types/client-form";
import CREATE_CLIENT from "@/apollo/projects/CreateClient.gql";
import CREATE_CARE_PLAN from "@/apollo/projects/CreateClientCarePlan.gql";
import UPDATE_CARE_PLAN from "@/apollo/projectActivities/UpdateCarePlan.gql";
import UPDATE_PROJECT_CLIENT from "@/apollo/projectActivities/UpdateProjectClient.gql";
import GET_PROJECT_CLIENT from "@/apollo/projectActivities/GetProjectClient.gql";
import GET_PROJECT_CARE_PLAN from "@/apollo/projectActivities/GetProjectCarePlan.gql";
import ModalFullScreen from "@/components/modal/ModalFullScreenNew.vue";
import FormGroup from "@/components/form/FormGroupNew.vue";
import FormInputGroup from "@/components/form/FormInputGroupNew.vue";
import FormDatepicker from "@/components/form/FormDatepicker.vue";
import UIButton from "@/components/button/ui-button.vue";
import _ from "lodash";

// Import tab components
import CreateClientTab from "./ClientTabsComponents/CreateClient.vue";
import ClientProfileTab from "./ClientTabsComponents/ClientProfileTab.vue";
import CarePlanTab from "./ClientTabsComponents/CarePlanTab.vue";
import SmartMatchTab from "./ClientTabsComponents/SmartMatchTab.vue";
import SmartMatchConfigModal from "@/components/smartMatch/SmartMatchConfigModal.vue";
import SmartMatchResultsModal from "@/components/smartMatch/SmartMatchResultsModal.vue";
import {
  carePlanFields,
  extractCarePlanData,
  removeCarePlanFields,
} from "@/entities/ProjectCarePlan";
import GET_SKILLS from "@/apollo/autocomplete-queries/GetSkills.gql";
import GET_SOFT_SKILLS from "@/apollo/autocomplete-queries/GetSoftSkills.gql";
import { User } from "@/generated/graphql";
import { makeid } from "@/utils";
import { NOTIFICATION } from "@/entities/Events";
import Message from "@/data/notificationsMessages";

@Component({
  components: {
    ModalFullScreen,
    FormGroup,
    FormInputGroup,
    FormDatepicker,
    UIButton,
    CreateClientTab,
    ClientProfileTab,
    CarePlanTab,
    SmartMatchTab,
    SmartMatchConfigModal,
    SmartMatchResultsModal,
  },
})
export default class ClientEditModal extends Vue {
  @Prop({ type: Boolean, default: false }) readonly dialog!: boolean;
  @Prop({ type: Boolean, default: false }) readonly isCareplanExist!: boolean;
  @Prop({ type: Boolean, default: false }) readonly isEdit: boolean;
  @Prop({ type: String, default: "lg2" }) readonly size!: string;
  @Prop({ type: String, required: true }) readonly companyId!: string;
  @Prop({ type: Object, required: true }) readonly currentUser!: User;
  @Prop({ type: Object }) readonly initialData: any;
  @Prop({ type: Object }) readonly initialCarePlan: any;
  @Prop({ type: Object, required: true }) readonly currentEditTab!: {
    tab: number;
    step: number;
  };

  currentTab = 0;
  currentStep = 0;
  visibleRange = { start: 0, end: 4 };
  formData: Record<string, any> = {};
  clientFormSteps: FormStep[] = clientFormSteps;
  tabs = tabs;
  contentClass = "modal-width adjustOverflowClient";
  scrollOffset = 0;
  clientCreated: boolean = false;
  createdClientId: string = "";
  createdCarePlan: string = "";
  showSmartMatchConfigModal: boolean = false;
  showSmartMatchResultsModal: boolean = false;

  get isLastStep(): boolean {
    return this.currentStep === this.clientFormSteps.length - 1;
  }
  get currentTabData() {
    return (
      this.tabs[this.currentTab] || {
        showSteps: false,
        steps: [],
        fields: [],
      }
    );
  }
  get currentTabTitle() {
    return "Client Information";
    //return this.tabs[this.currentTab].title;
  }
  
  get availableTabs() {
    // if (this.isEdit || this.clientCreated) {
    //   // Show Smart Match tab for existing clients
    //   return [...this.tabs, { title: "Smart Match", showSteps: false, steps: [], fields: [] }];
    // }
    return [...this.tabs, { title: "Smart Match", showSteps: false, steps: [], fields: [] }];
  }
  created() {
    this.loadFormData();
    if (this.isEdit) {
      this.clientCreated = true;
      this.createdClientId = this.$route.params.id || this.initialData.id;
    }
    this.currentTab = this.currentEditTab.tab;
  }
  clientEdit() { }
  loadFormData() {
    const draftKey = `clientFormDraft_${this.$route.params.id}`;
    const savedDraft = localStorage.getItem(draftKey);
    if (savedDraft) {
      this.formData = JSON.parse(savedDraft);
    } else {
      this.formData = _.omit(this.initialData, ["__typename"]);
    }
  }

  // Debounced form data update
  private debouncedUpdate = _.debounce((newData: Record<string, any>) => {
    // this.$emit('update:formData', newData);
    // WIPP add Edit Client Logic
  }, 300);

  handleFormDataUpdate(newData: Record<string, any>) {
    this.formData = { ...this.formData, ...newData };
    this.debouncedUpdate(this.formData);
  }

  async handleSaveDraft(isDrfat, currentTabName) {
    const cleanedData = _.omit(this.formData, ["__typename"]);
    // this.$emit('save-draft', cleanedData);
    try {
      await this.saveClientData(isDrfat, currentTabName, cleanedData);
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  }

  async onSubmit(isDrfat, currentTabName) {
    try {
      const cleanedData = _.omit(this.formData, ["__typename"]);
      // await this.$emit('submit', cleanedData);
      await this.saveClientData(isDrfat, currentTabName, cleanedData);
      // this.closeModal();
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  }
  closeModal() {
    this.$emit("close");
  }
  closeModalDialog() {
    this.$emit('closeDialog');
  }
  
  handleOpenConfigModal() {
    this.showSmartMatchConfigModal = true;
  }
  
  handleCloseConfigModal() {
    this.showSmartMatchConfigModal = false;
  }
  
  handleOpenResultsModal() {
    this.showSmartMatchResultsModal = true;
  }
  
  handleCloseResultsModal() {
    this.showSmartMatchResultsModal = false;
  }
  getFieldComponent(type: string): string {
    const componentMap = {
      input: "FormInputGroup",
      select: "FormSelect",
      textarea: "FormTextarea",
      multiselect: "FormMultiselect",
      datepicker: "FormDatepicker",
      toggle: "FormToggle",
    };
    return componentMap[type] || "FormInputGroup";
  }

  async saveClientData(
    isDraft: boolean = false,
    TabNumber: number,
    formData: any
  ): Promise<void> {
    try {
      const projectData = { ...formData };
      delete projectData.client_services;
      // Extract care plan data
      const carePlanData = extractCarePlanData(projectData);

      // Convert array fields in carePlanData to strings
      const arrayCarePlanFields = [
        "client_services", // Add other array fields here if needed
      ];

      arrayCarePlanFields.forEach((field) => {
        if (carePlanData[field] && Array.isArray(carePlanData[field])) {
          carePlanData[field] = `{${carePlanData[field]
            .map((item) => `"${item}"`)
            .join(",")}}`;
        }
      });

      // Remove care plan fields from project data
      const cleanProjectData = removeCarePlanFields(projectData);

      // Process array fields, select fields, and other logic as before
      const arrayFields = [
        "pets",
        "hobbies",
        "support_type",
        "communication_languages_spoken",
      ];

      const selectFields = [
        "access_type",
        "self_directed_care_preferences",
        "emergency_relationship",
        "communication_ability",
        "preferred_language",
        "dnr_copy_attached",
        "mobility_status",
        "dnr_order",
        "visual_communication_style",
        "preferred_communication_style",
        "interpreter_needed",
        "mobility_level",
        "frequency",
        "support_type",
      ];

      // Process array fields
      arrayFields.forEach((field) => {
        if (cleanProjectData[field] && Array.isArray(cleanProjectData[field])) {
          cleanProjectData[field] = `{${cleanProjectData[field]
            .map((tag) => `"${tag.value || tag}"`)
            .join(",")}}`;
        } else {
          delete cleanProjectData[field];
        }
      });

      // Process select fields
      selectFields.forEach((field) => {
        if (cleanProjectData[field]) {
          cleanProjectData[field] =
            typeof cleanProjectData[field] === "object" &&
              cleanProjectData[field] !== null
              ? cleanProjectData[field]?.value
              : cleanProjectData[field];
        }
      });

      // Extract medications from form data
      const medications = cleanProjectData.client_medications || [];
      delete cleanProjectData.client_medications;
      delete cleanProjectData.__typename;

      // Prepare medications for upsert
      const medicationsToUpsert = medications?.map((med) => ({
        id: med?.id,
        client_id: this.$route.params.id,
        name: med?.name,
        dosage: med?.dosage,
        frequency: med?.frequency,
        file: med?.file,
      }));

      // Construct skills data
      const {
        skillsIds,
        softSkillsIds,
        manager,
        project_skills,
        new_skills,
        new_soft_skills,
        tags,
        personalSkills,
        personalSoftSkills,
        projectSkillsIds,
        projectSoftSkillsIds,
        phone,
        manager_id,
        project_id,
        customSkills,
        ...clientDataWithoutSkillsIds
      } = cleanProjectData;

      let managerId = null;

      if (cleanProjectData.manager_id) {
        managerId = Array.isArray(cleanProjectData.manager_id)
          ? cleanProjectData.manager_id[0]
          : cleanProjectData.manager_id;
      }

      const finalCleanData = {
        manager_id: managerId,
        ...clientDataWithoutSkillsIds,
      };

      if (isDraft) {
        finalCleanData["drafted"] = true;
      } else {
        finalCleanData["drafted"] = false;
      }
      const response = await this.$apollo.query({
        query: GET_SKILLS,
        variables: {
          where: {
            name: { _in: finalCleanData.new_skills || [] }, // Check if skills with these names exist
          },
        },
      });

      const existingSkills = response?.data?.skills_short_name_first || [];
      const newSkillsToAdd = cleanProjectData.new_skills?.filter(
        (skillName) =>
          !existingSkills.some(
            (existingSkill) => existingSkill.name === skillName
          )
      );

      // Check for existing soft skills  
      const softSkillResponse = await this.$apollo.query({
        query: GET_SOFT_SKILLS,
        variables: {
          where: {
            name: { _in: finalCleanData.new_soft_skills || [] }, // Check if soft skills with these names exist
          },
        },
      });

      const existingSoftSkills = softSkillResponse?.data?.soft_skill || [];
      const newSoftSkillsToAdd = cleanProjectData.new_soft_skills?.filter(
        (softSkillName) =>
          !existingSoftSkills.some(
            (existingSoftSkill) => existingSoftSkill.name === softSkillName
          )
      );
      if (this.isEdit || this.clientCreated === true) {
        // Update client data
        const response = await this.$apollo.mutate({
          mutation: UPDATE_PROJECT_CLIENT,
          variables: {
            where: {
              id: { _eq: this.$route.params.id || this.createdClientId },
            },
            set: finalCleanData,
            projectId: this.$route.params.id || this.createdClientId,
            medicationsToUpsert,
            deleteSkillsIds: cleanProjectData.projectSkillsIds
              ? cleanProjectData.projectSkillsIds
              : [],
            addSkills: cleanProjectData.skillsIds
              ? cleanProjectData.skillsIds.map((skill) => ({
                project_id: this.createdClientId || this.$route.params.id,
                skill_id: skill.id || skill,
              }))
              : [],
            updatePersonalSkills: cleanProjectData.skillsIds
              ? cleanProjectData.skillsIds?.map(({ id }) => ({
                id,
                user_id: this.currentUser.id,
                company_id: this.companyId,
              }))
              : [],
            customSkills: TabNumber === 0 ? newSkillsToAdd
              ? newSkillsToAdd?.map((skillName) => ({
                name: skillName,
                company_id: this.companyId,
                project_skills: {
                  data: {
                    project_id: this.$route.params.id || this.createdClientId,
                  },
                },
              }))
              : [] : [],
            deleteSoftSkillsIds: cleanProjectData.projectSoftSkillsIds
              ? cleanProjectData.projectSoftSkillsIds
              : [],
            addSoftSkills: cleanProjectData.softSkillsIds
              ? cleanProjectData.softSkillsIds.map((softSkillId) => ({
                project_id: this.createdClientId || this.$route.params.id,
                soft_skill_id: softSkillId,
                created_at: new Date(),
                updated_at: new Date(),
              }))
              : [],
            updatePersonalSoftSkills: cleanProjectData.personalSoftSkills
              ? cleanProjectData.personalSoftSkills?.map(({ id, name }) => ({
                id,
                name,
                user_id: this.currentUser.id,
                company_id: this.companyId,
                created_at: new Date(),
                updated_at: new Date(),
              }))
              : [],
            customSoftSkills: TabNumber === 0 ? newSoftSkillsToAdd
              ? newSoftSkillsToAdd?.map((softSkillName) => ({
                name: softSkillName,
                company_id: this.companyId,
                created_at: new Date(),
                updated_at: new Date(),
                project_soft_skills: {
                  data: {
                    project_id: this.$route.params.id || this.createdClientId,
                    created_at: new Date(),
                    updated_at: new Date(),
                  },
                },
              }))
              : [] : [],
          },
          refetchQueries: [
            {
              query: GET_PROJECT_CLIENT,
              variables: {
                where: {
                  id: { _eq: this.$route.params.id || this.createdClientId },
                },
              },
            },
            {
              query: GET_PROJECT_CARE_PLAN,
              variables: {
                project_id: this.$route.params.id || this.createdClientId,
              },
            },
          ],
        });
        // Update care plan if TabNumber is 2
        if (TabNumber === 2 && (this.isCareplanExist || this.createdCarePlan)) {
          await this.$apollo.mutate({
            mutation: UPDATE_CARE_PLAN,
            variables: {
              project_id: this.$route.params.id || this.createdClientId,
              set: carePlanData,
            },
          });
        }
        if (TabNumber === 2 && !this.isCareplanExist) {
          await this.$apollo.mutate({
            mutation: CREATE_CARE_PLAN,
            variables: {
              client_obj: {
                ...carePlanData,
                project_id: this.$route.params.id,
              },
            },
          });
        }

        if (isDraft) {
          if (!this.$route.params.id) {
            if (TabNumber === 2) {
              this.closeModal();
              this.$eventBus.emit(
                NOTIFICATION,
                Message.successMessage("Data Updated successfully.")
              );
            }
            if (TabNumber === 1) {
              this.currentTab = 2;
              this.currentStep = 0;
            }
              if (TabNumber === 0) {
              this.closeModal();
               this.$eventBus.emit(
                NOTIFICATION,
                Message.successMessage("Data Updated successfully.")
              );
          }
          }
          else {
            this.closeModal();
            this.$eventBus.emit(
              NOTIFICATION,
              Message.successMessage("Data Updated successfully.")
            );
          }
        } else {
          if (TabNumber === 0 && !this.$route.params.id) {
            this.currentTab = 1;
            this.currentStep = 0;
          } else if (TabNumber === 1 && !this.$route.params.id) {
            this.currentTab = 2;
            this.currentStep = 0;
          } else if (TabNumber === 2 && !this.$route.params.id) {
            this.currentTab = 3;
            this.currentStep = 0;
            this.$eventBus.emit(
              NOTIFICATION,
              Message.successMessage("Data Updated successfully.")
            );
          }
        }
      } else {
        // Create new client
        const skillToAdd = cleanProjectData.skillsIds ? cleanProjectData.skillsIds : [];
        const newSkill = cleanProjectData.new_skills ? cleanProjectData.new_skills : [];
        const softSkillToAdd = cleanProjectData.softSkillsIds ? cleanProjectData.softSkillsIds : [];
        const newSoftSkill = cleanProjectData.new_soft_skills ? cleanProjectData.new_soft_skills : [];
        const {
          skillsIds,
          softSkillsIds,
          manager,
          project_skills,
          customSkills,
          personalSkills,
          personalSoftSkills,
          new_skills,
          new_soft_skills,
          projectSkillsIds,
          projectSoftSkillsIds,
          phone,
          manager_id,
          ...clientDataWithoutSkillsIds
        } = cleanProjectData;
        const managerId = cleanProjectData.manager_id?.[0] || null;


        const response = await this.$apollo.mutate({
          mutation: CREATE_CLIENT,
          variables: {
            skillIds: skillToAdd?.map((skillId) => Number(skillId)),
            companyId: this.companyId,
            userId: this.currentUser.id,
            client_obj: {
              company_id: this.companyId,
              drafted: isDraft,
              ...clientDataWithoutSkillsIds,
              manager_id: managerId,
              created_at: new Date(),
              project_skills: {
            data: [
              ...skillToAdd?.map((skillId) => ({
                skill_id: skillId,
              })),
              ...newSkill?.map((skillName) => ({
                skill: {
                  data: {
                    name: skillName,
                    company_id: this.companyId,
                  },
                },
              })),
            ],
          },
              slug: `${cleanProjectData.name}__${makeid(4)}`,
            },
          },
        });
    
        const clientId = response?.data?.insert_project_one?.id;

        // Add soft skills separately using UPDATE_PROJECT_CLIENT
        if (softSkillToAdd?.length > 0 || newSoftSkill?.length > 0) {
          await this.$apollo.mutate({
            mutation: UPDATE_PROJECT_CLIENT,
            variables: {
              where: {
                id: { _eq: clientId },
              },
              set: {},
              projectId: clientId,
              medicationsToUpsert: [],
              deleteSkillsIds: [],
              addSkills: [],
              updatePersonalSkills: [],
              customSkills: [],
              deleteSoftSkillsIds: [],
              addSoftSkills: softSkillToAdd?.map((softSkillId) => ({
                project_id: clientId,
                soft_skill_id: softSkillId,
                created_at: new Date(),
                updated_at: new Date(),
              })) || [],
              updatePersonalSoftSkills: [],
              customSoftSkills: newSoftSkill?.map((softSkillName) => ({
                name: softSkillName,
                company_id: this.companyId,
                created_at: new Date(),
                updated_at: new Date(),
                project_soft_skills: {
                  data: {
                    project_id: clientId,
                    created_at: new Date(),
                    updated_at: new Date(),
                  },
                },
              })) || [],
            },
          });
        }

        const responseCarePlan = await this.$apollo.mutate({
          mutation: CREATE_CARE_PLAN,
          variables: {
            client_obj: {
              ...carePlanData,
              project_id: clientId,
            },
          },
        });
        const carePlanId = responseCarePlan?.data?.insert_client_care_plan_one?.id;
        this.createdClientId = clientId;
        if (TabNumber === 0) {
          this.currentTab = 1;
          this.createdClientId = clientId;
          this.createdCarePlan = carePlanId;
          this.clientCreated = true;
          this.currentStep = 0;
        } else if (TabNumber === 1) {
          this.currentTab = 2;
          this.createdClientId = clientId;
          this.createdCarePlan = carePlanId;
          this.clientCreated = true;
          this.currentStep = 0;
        } else if (TabNumber === 2) {
          // Create care plan
          this.currentTab = 3;
          this.createdClientId = clientId;
          this.$eventBus.emit(
            NOTIFICATION,
            Message.successMessage("Client created successfully.")
          );
        }
      }
    } catch (error) {
      console.error("Error updating client:", error);
      this.$emit("update:error", error);
    }
  }

  // Add new computed property and method
  get requiredFieldsByStep(): Record<number, string[]> {
    return this.clientFormSteps.reduce((acc, step, index) => {
      acc[index] = step.fields.map((field) => field.key);
      return acc;
    }, {});
  }
  @Watch("currentStep")
  handleMainTabChange(index: number) {
    this.currentTab = index;
    this.currentStep = 0;
  }
  isStepComplete(stepIndex: number): boolean {
    const requiredFields = this.requiredFieldsByStep[stepIndex];
    return requiredFields.every(
      (field) =>
        this.initialData[field] !== undefined &&
        this.initialData[field] !== null &&
        this.initialData[field] !== ""
    );
  }
}
